<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title"><i class="back-btn" @click="goBack"></i>实名认证</div>
    <div class="separator"></div>
    <div class="account-wrap auth-info">
    	<div class="wrap-item">
    		<span class="item-label auth-label">姓名： </span>
    		<input type="text" v-model="auth.name" placeholder="请输入您的姓名" />
    	</div>
    	<div class="wrap-item">
    		<span class="item-label auth-label">身份证： </span>
    		<input type="text" v-model="auth.IDCard" placeholder="请输入您的身份证号码" />
    	</div>
    </div>
    <div class="separator"></div>
    <div class="auth-upload">
    	<div class="upload-title">拍摄并上传身份证</div>
    	<div class="upload-wrap">
    		<cube-upload
    			class="box-wrap"
				  ref="frontUpload"
				  v-model="auth.front"
				  :action="frontAct"
				  :max="1"
				  @files-added="addFront"
				  @file-success="successFront"
				  @file-error="errFront">
				  <div class="clearfix">
				    <cube-upload-file v-for="(file, i) in auth.front" :file="file" :key="i"></cube-upload-file>
				    <cube-upload-btn :multiple="false">
				      <div class="upload-btn">
				        <i></i>
				        <p>上传身份证正面</p>
				      </div>
				    </cube-upload-btn>
				  </div>
				</cube-upload>
				<cube-upload
					class="box-wrap"
				  ref="backPpload"
				  v-model="auth.back"
				  :action="backAct"
				  :max="1"
				  @files-added="addBack"
				  @file-success="successBack"
				  @file-error="errNack">
				  <div class="clearfix">
				    <cube-upload-file v-for="(file, i) in auth.back" :file="file" :key="i"></cube-upload-file>
				    <cube-upload-btn :multiple="false">
				      <div class="upload-btn">
				        <i></i>
				        <p>上传身份证背面</p>
				      </div>
				    </cube-upload-btn>
				  </div>
				</cube-upload>
    	</div>
    	<div class="upload-notice">
    		温馨提示：请上传原始比例的身份证正反面，请勿剪裁涂改，保证身份信息清晰显示，否则无法通过审核。
    	</div>
    	<div class="tusd-btn">提交</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'auth',
  data(){
  	return {
  		auth:{
  			name:'',
  			IDCard:'',
  			front:[],
  			back:[]
  		},
  		frontAct:{
  			target: ''
  		},
  		backAct:{
  			target: ''
  		},
  		params:{}
  	}
  },
  methods:{
  	goBack(){
  		this.$router.push({name:this.params.back})
  	},
  	addFront(){
  		
  	},
  	successFront(){
  		
  	},
  	errFront(){
  		
  	},
  	addBack(){
  		
  	},
  	successBack(){
  		
  	},
  	errBack(){
  		
  	}
  },
  created(){
  	this.params = this.$store.state.routerStore.auth
  }
}
</script>

<style lang="less" scoped>
	.auth-info{
		padding:14px 26px 26px;
	}
	.auth-upload{
		padding:26px;
		.upload-title{
			font-size:15px!important;
			color:#d9e3fd
		}
		.upload-wrap{
			display: flex;
			justify-content: space-between;
			margin-top: 20px;
			.box-wrap{
				width: 48.5%;
				height: 110px;
				padding:0px;
				.upload-btn{
					padding-top:14%;
					text-align: center;
					i{
						display: inline-block;
						width: 30px;
						height: 30px;
						background: url(../assets/images/add.svg) center center no-repeat;
					}
					p{
						padding-top:10px;
						color:#8092c6;
					}
				}
			}
		}
		.upload-notice{
			margin: 14px 0px 36px;
			font-size:12px!important;
			color:#575f8d;
			line-height: @notice-height;
		}
	}
	@media screen and (min-width:380px ) {
		.auth-upload{
			.upload-wrap{
				.box-wrap{
					height: 120px;
				}
			}
		}
	}
	@media screen and (max-width:370px ) {
		.auth-upload{
			.upload-wrap{
				.box-wrap{
					height: 105px;
				}
			}
		}
	}
	@media screen and (max-width:320px ) {
		.auth-upload{
			.upload-wrap{
				.box-wrap{
					height: 94px;
					.upload-btn{
						p{
							font-size:13px!important;
						}
					}
				}
			}
		}
	}
</style>
